import React, { createContext, useContext } from 'react';

export interface CompanyInfoContextValue {
  canViewCompanyInfo: boolean;
  companyProfilesPath: string;
}

// Without a provider the feature is off: triggers render as plain text and the
// hooks never fetch.
const CompanyInfoContext = createContext<CompanyInfoContextValue>({
  canViewCompanyInfo: false,
  companyProfilesPath: '',
});

export const useCompanyInfoContext = () => useContext(CompanyInfoContext);

type CompanyInfoProviderProps = {
  value: CompanyInfoContextValue;
  children: React.ReactNode;
};

export const CompanyInfoProvider = ({
  value,
  children,
}: CompanyInfoProviderProps) => (
  <CompanyInfoContext.Provider value={value}>
    {children}
  </CompanyInfoContext.Provider>
);
